import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AISuggestionCard = ({ suggestion, onSchedule }) => {
  const getTypeColor = (type) => {
    if (type === 'high-performing') return 'var(--color-success)';
    if (type === 'trending') return 'var(--color-accent)';
    if (type === 'timing') return 'var(--color-primary)';
    if (type === 'format') return 'var(--color-warning)';
    return 'var(--color-muted-foreground)';
  };

  const getConfidenceColor = (confidence) => {
    if (confidence >= 90) return 'text-success';
    if (confidence >= 80) return 'text-primary';
    if (confidence >= 70) return 'text-accent';
    return 'text-muted-foreground';
  };

  return (
    <div className="bg-background rounded-lg p-3 border border-border hover:border-primary/30 transition-all">
      {/* Header */}
      <div className="flex items-start gap-2 mb-2">
        <div
          className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: `${getTypeColor(suggestion?.type)}20` }}
        >
          <Icon name={suggestion?.icon} size={16} color={getTypeColor(suggestion?.type)} />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-foreground mb-1">{suggestion?.title}</h4>
          <p className="text-xs text-muted-foreground line-clamp-2">{suggestion?.description}</p>
        </div>
      </div>

      {/* Confidence Score */}
      <div className="mb-3">
        <div className="flex items-center justify-between mb-1">
          <span className="text-xs text-muted-foreground">AI Confidence</span>
          <span className={`text-xs font-semibold ${getConfidenceColor(suggestion?.confidence)}`}>
            {suggestion?.confidence}%
          </span>
        </div>
        <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{
              width: `${suggestion?.confidence}%`,
              backgroundColor: getTypeColor(suggestion?.type)
            }}
          ></div>
        </div>
      </div>

      {/* Suggested Topics */}
      {suggestion?.suggestedTopics && suggestion?.suggestedTopics?.length > 0 && (
        <div className="mb-3">
          <p className="text-xs text-muted-foreground mb-2">Suggested Topics:</p>
          <div className="flex flex-wrap gap-1">
            {suggestion?.suggestedTopics?.map((topic, index) => (
              <span
                key={index}
                className="text-xs px-2 py-1 rounded-full bg-muted text-foreground"
              >
                {topic}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Action Button */}
      <Button
        variant="outline"
        size="xs"
        iconName="Calendar"
        className="w-full"
        onClick={() => onSchedule?.(suggestion)}
      >
        Create Content
      </Button>
    </div>
  );
};

export default AISuggestionCard;